import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from 'raviger';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import { reportSelect } from '../../store/actions/report';
import { alertAdd } from '../../store/actions/alert';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import SideMenu from '../../components/SideMenu/SideMenu';
import Report from '../../components/Reports/Reports';

import * as constants from '../../constants';

class FranchiseReport extends Component {
    componentDidMount() {
        this.props.onBreadcrumbAddRoute({ key: 'show_report', text: 'Show Report', path: window.location.pathname });

        if (window.location.pathname.includes('/reports/report')) {
            // NOTE: Temporary until component is written for hooks
            const reportKey = window.location.pathname.replace('/reports/report/', '');

            this.props.onReportSelect({ reportId: reportKey });
        }
    };

    componentDidUpdate() {
        if (this.props.lastState === constants.STATE_FAIL && this.props.error && this.props.error.message) {
            this.props.onAlertAdd({ key: constants.ALERT_SERVER_ERROR, text: <strong>{this.props.error.message}</strong>, type: constants.ALERT_TYPE_DANGER });
        }
    };

    componentWillUnmount() {
        this.props.onBreadcrumbRemoveRoute();
    };

    cancelledHandler = () => {
        navigate(`/reports`);
    };

    render() {
        return (
            <React.Fragment>
                <SideMenu activeKey="reports" />
                <div className="content-body">
                    <div style={{ paddingRight: '15px' }}>
                        <Report
                            cancelled={() => this.cancelledHandler()} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

const mapStateToProps = (state) => ({
    error: state.error
});

const mapDispatchToProps = (dispatch) => ({
    onBreadcrumbAddRoute: (crumb) => dispatch(breadcrumbAddRoute(crumb)),
    onBreadcrumbRemoveRoute: (crumb) => dispatch(breadcrumbRemoveRoute(crumb)),
    onReportSelect: (options) => dispatch(reportSelect(options)),
    onAlertAdd: (alert) => dispatch(alertAdd(alert))
});

export default withLayout(withAuthentication(connect(mapStateToProps, mapDispatchToProps)(FranchiseReport)));
